// Sofort ausführen und dann alle 500ms wiederholen, um die Dankesnachricht zu finden
(function checkAndRedirect() {
  // Prüfen, ob wir auf der Follower-Deals Seite sind
  if (window.location.pathname.includes('/pages/follower-deals')) {
    // Prüfen, ob das Formular abgesendet wurde (durch Suchen nach Texten in der Dankesnachricht)
    var pageContent = document.body.textContent || document.body.innerText;
    
    if (pageContent.includes('Danke') || pageContent.includes('vorgemerkt') || document.querySelector('.hulkapps-form-thank-you-message')) {
      console.log("Dankesnachricht erkannt, Weiterleitung in 5 Sekunden");
      
      // Nach 5 Sekunden zur Produktseite weiterleiten
      setTimeout(function() {
        console.log("Weiterleitung wird jetzt ausgeführt");
        window.location.href = 'https://vision-beauty.com/pages/follower-produkte';
      }, 5000 );
      
      // Funktion nicht mehr wiederholen, wenn Dankesnachricht gefunden wurde
      return;
    }
  }
  
  // Alle 500ms erneut prüfen
  setTimeout(checkAndRedirect, 500);
})();